import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isLeapYear);
dayjs.extend(isoWeeksInYear);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

/**
 * Return the year and week as a string
 * @param year
 * @param week
 */
export const toYearWeekString = (year: number, week: number): string => {
	return `${year}${addLeadingZeroToSingleDigitWeeks(week)}`;
};

/**
 * Adds leading zero's before week numbers below 10 (single digit numbers)
 *
 * @param week
 */
export const addLeadingZeroToSingleDigitWeeks = (week: number) => {
	return week < 10 ? '0' + week.toString().slice(-2) : week.toString();
};
